/* Models */
import { Content } from '../models';

/* ActionTypes */
import { CONTENT_ENTITY_ACTION_TYPES, UPDATE_CONTENT_PROGRESS } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

function specificReducer(state, { type, payload }) {
  if (type === UPDATE_CONTENT_PROGRESS) {
    const { id, progress } = payload;
    return state.setIn([id, 'vod', 'progress'], progress);
  }

  return state;
}

const contentsReducer = generateEntityReducer(
  CONTENT_ENTITY_ACTION_TYPES,
  Content,
  specificReducer,
);

export default contentsReducer;
